import React, { Component } from 'react';
import { translate } from 'react-i18next';

import Utils from 'utils/Utils.js';
import UserService from '../../services/UserService.js';

import ForgotPassword from './ForgotPassword'

class ForgotPasswordContainer extends Component {

    constructor(props){
		super(props);
		this.state = {valid:false,
                      email:'',
                      emailError:'',
                      error:'',
                      message:''};    

		this.onEmailChange = this.onEmailChange.bind(this);
		this.onResetRequest = this.onResetRequest.bind(this);
        this.isValid = this.isValid.bind(this);
    }

	onEmailChange(event) {
		this.setState({email: event.target.value, emailError:''}, this.isValid);
	}

	onResetRequest(event) {
        if(this.isValid(true)) {
			UserService.resetPassword(this.state.email).then(()=>{
                this.setState({message:this.props.t('password_reset_message')});
			},(error) => {
                this.setState({error:String(error)});
				console.error("error", error);
			});
        }
	}
	
	isValid(submit) {
        var t = this.props.t;
		var valid = true;

		this.setState({emailError:'',passwordError:''});

		if(this.state.email.length>0 && !Utils.validateEmail(this.state.email||'')){
            if(submit) {
			    this.setState({emailError:t('Invalid email address')});
            }
            valid = false;
		}

		if((this.state.email||'').length === 0){
            if(submit) {
			    this.setState({emailError:t('Please enter your email address')});
            }
            valid = false;
		}

        this.setState({valid:valid});

		return valid;	
	}


    render() {
      return (
         <ForgotPassword valid={this.state.valid}
                email={this.state.email}
                onEmailChange={this.onEmailChange}
                emailError={this.state.emailError}
                error={this.state.error}
                message={this.state.message}
                onResetRequest={this.onResetRequest}
                onClose={this.props.onClose} />
      );
  }
}

export default translate('authentication')(ForgotPasswordContainer);



// WEBPACK FOOTER //
// ./src/modules/authentication/ForgotPasswordContainer.js